export const SET_AUTH_LOADING = 'SET_AUTH_LOADING'
export const SET_USER = 'SET_USER'

export const GET_USER_ACTIONS_REQUEST = 'GET_USER_ACTIONS_REQUEST'
export const GET_USER_ACTIONS_SUCCESS = 'GET_USER_ACTIONS_SUCCESS'
export const GET_USER_ACTIONS_FAILED = 'GET_USER_ACTIONS_FAILED'